import { render } from "./KpiDashboard.vue?vue&type=template&id=8ccfbf66&scoped=true&ts=true&lang=pug"
import script from "./KpiDashboard.vue?vue&type=script&lang=ts"
export * from "./KpiDashboard.vue?vue&type=script&lang=ts"

import "./KpiDashboard.vue?vue&type=style&index=0&id=8ccfbf66&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ccfbf66"]])

export default __exports__